const constants = {
    USER: "USER",
    ADMIN: "ADMIN",
    ATTEND: "ATTEND",
    ASSIST: "ASSIST",
    SYSADMIN: "SYSADMIN",
};

export default constants;